import React from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableRow } from '@mui/material';

import OnEditIcon from '../../../icons/OnEditIcon';
import { reverseFormatDate } from '../../../utils/dateFunctions';

import classes from '../../../commonStyles/tables.module.css';

const EPCRatingTableRow = ({ row, isEditDisabled, onEdit }) => {
    return (
        <TableRow hover className={`${classes.basicRowStripes}`}>
            <TableCell>{reverseFormatDate(row.dateAdded)}</TableCell>
            <TableCell>{row.epcRating}</TableCell>
            <TableCell align="right">
                <OnEditIcon onEdit={() => onEdit(row)} active={!isEditDisabled} />
            </TableCell>
        </TableRow>
    );
};

EPCRatingTableRow.propTypes = {
    row: PropTypes.object,
    isEditDisabled: PropTypes.bool,
    onEdit: PropTypes.func
};

export default EPCRatingTableRow;
